<template>
  <span>
    <v-row no-gutters v-for="(relation, idx) in relationsList" :key="idx">
      <the-relation :relation="relation" :dataSourceName="dataSourceName" :featureId="featureId" />
    </v-row>
  </span>
</template>
<script>
import { get } from 'vuex-pathify';
import TheRelation from '@/components/TheRelation';
export default {
  name: 'RelationsList',
  components: { TheRelation },
  props: {
    featureId: {
      type: [String, Number],
      required: true,
    },
    dataSourceName: {
      type: String,
      required: true,
    },
  },
  computed: {
    relations: get('relations/relations'),
    relationsList() {
      return this.relations?.[this.dataSourceName]?.[this.featureId] || [];
    },
  },
};
</script>
